export default state => ({ knownClasses: state.knownClasses });



// WEBPACK FOOTER //
// ./src/app/api/redux-watson/app-config/migrations/0000.js